export class AssetDropdownOption {
    id?: number;
    name: string;
    dtIds?: number[];
    buildingId?: number;
    buildingIds?: number[];
    dtId?: number;
    poleId?: number;
    substationId?: number;
    cimSubstationIds?: number[];

    constructor(data?: any) {
        this.name = data?.name ?? '';
        this.dtIds = data?.dtIds ?? [];
        this.buildingId = data?.buildingId ?? 0;
        this.buildingIds = data?.buildingIds ?? [];
        this.dtId = data?.dtId ?? 0;
        this.poleId = data?.poleId ?? 0;
        this.substationId = data?.substationId ?? 0;
        this.cimSubstationIds = data?.cimSubstationIds ?? [];
    }
}